import * as aeService from '/source/js/services/assistedEnrollmentService';
import sponsorItemTmpl from './partials/sponsorItem.hbs';
import placementSponsorItemTmpl from './partials/placementSponsorItem.hbs';
import {
    loadSpinner,
    stopSpinner
} from '/source/_patterns/01-components/spinner/spinner';

let currentMemberId = '';
let allFlowEnabled;
// list of downline data
/* example
[
    {
        "enrollingSponsorName": "May your jimmies be unrustled.",
        "enrollingSponsorId": 8810537,
        "enrollingSponsorPlacementLocation": "Left",
        "hasDelegate": true,
        "placementSponsorDelegateName": "The Example",
        "placementSponsorDelegateId": 15462216,
        "placementSponsorDelegatePlacementLocation": "Left"
    }
]
*/
let downlineResult = [];
// list of placement data
/* example
[
    {
        "placementSponsorName": "The Example",
        "placementSponsorId": 15462216,
        "placementLocation": "Left"
    }
]
*/
let placementDataResult = [];

// currentPlacementData
let currentPlacementData = {
    enrollingSponsorName: '',
    enrollingSponsorId: '',
    placementSponsorName: '',
    placementSponsorId: '',
    placementPosition: '',
    placementPositionText: '',
    hasDelegate: '',
    previousEnrollingSponsorName: '',
    previousPlacementSponsorName: ''
};

let youLabel = 'You';

function openEditEnrollModal(e) {
    if(e) {
        e.preventDefault();
    }
    $('.main').hide();
    $('.enroll').show();
    clearEnrollingSearchInputAndResults();
}

function closeEditEnrollModal(e) {
    if(e) {
        e.preventDefault();
    }
    $('.main').show();
    $('.enroll').hide();
}

function openEditPlacementModal(e) {
    if(e) {
        e.preventDefault();
    }
    $('.main').hide();
    $('.placement').show();
    clearPlacementSearchInputAndResults();
}

function closeEditPlacementModal(e) {
    if(e) {
        e.preventDefault();
    }
    $('.main').show();
    $('.placement').hide();
}

async function searchEnrollInput(e) {
    if(e) {
        e.preventDefault();
    }
    downlineResult = [];
    let searchText = $('.enroll__sponsor-input').val();
    if(!searchText) return;

    try {
        loadSpinner();
        let result = await aeService.searchDownlineSponsor({
            searchCriteria: searchText
        });
        if(result.length === 0) {
            $('.enroll__no_results').show();
        } else {
            $('.enroll__no_results').hide();
        }
        const updateBtnText = $('#editPlacementModal').data('update-button-text');
        result = result.map((res) => ({ ...res, allFlowEnabled, updateBtnText }));
        downlineResult = result;
        let HTMLmarkup = sponsorItemTmpl(downlineResult);

        $('.enroll__results-list').html(HTMLmarkup);
        stopSpinner();
    } catch (e) {
        console.log(e);
    }
}

async function searchPlacementInput(e) {
    if(e) {
        e.preventDefault();
    }
    placementDataResult = [];
    let searchText = $('.placement__sponsor-input').val();
    if(!searchText) return;

    let searchEnrollingSponsorId = currentPlacementData.enrollingSponsorId;

    if(!searchEnrollingSponsorId == null) return;

    try {
        loadSpinner();
        let result = await aeService.searchPlacementSponsor({
            searchCriteria: searchText,
            enrollingSponsorId: searchEnrollingSponsorId
        });

        if(result.length === 0) {
            $('.placement__no_results').show();
        } else {
            $('.placement__no_results').hide();
        }
        const updateBtnText = $('#editPlacementModal').data('update-button-text');
        result = result.map((res) => ({ ...res, allFlowEnabled, updateBtnText }));
        placementDataResult = result;
        let HTMLmarkup = placementSponsorItemTmpl(placementDataResult);

        $('.placement__results-list').html(HTMLmarkup);
        stopSpinner();
    } catch (ex) {
        console.log(ex);
    }
}

function setAssignedEnrollSponsor() {
    let $this = $(this);
    let enrollingSponsorId = $this.data('memberid');
    var placementData = downlineResult.find(
        (i) => i.enrollingSponsorId === enrollingSponsorId
    );

    if(!placementData) {
        console.error(`cannot find placement data for ${enrollingSponsorId}`);
        return;
    }
    setCurrentPlacementData(placementData);
    currentPlacementData.IsPlacementConfirmed = false;
    displayCurrentPlacementData();
    if(!allFlowEnabled) closeEditEnrollModal();
    hideResults('enroll');
}

function setCurrentPlacementData(placementData) {
    currentPlacementData.previousEnrollingSponsorName = currentPlacementData.enrollingSponsorName;
    currentPlacementData.previousPlacementSponsorName = currentPlacementData.placementSponsorName;
    currentPlacementData.enrollingSponsorId = placementData.enrollingSponsorId;
    currentPlacementData.enrollingSponsorName =
    placementData.enrollingSponsorName;
    currentPlacementData.hasDelegate = placementData.hasDelegate;
    currentPlacementData.placementPosition =
    placementData.placementSponsorDelegatePlacementLocation;
    currentPlacementData.placementSponsorId =
    placementData.placementSponsorDelegateId;
    currentPlacementData.placementSponsorName =
        placementData.placementSponsorDelegateName;
}

function setCurrentPlacement(placement) {
    currentPlacementData.previousPlacementSponsorName = currentPlacementData.placementSponsorName;
    currentPlacementData.placementPosition = placement.placementLocation;
    currentPlacementData.placementSponsorId = placement.placementSponsorId;
    currentPlacementData.placementSponsorName = placement.placementSponsorName;
}

function setCurrentPlacementPosition(placement, placementText) {
    currentPlacementData.placementPosition = placement;
    $('#PlacementPosition').val(currentPlacementData.placementPosition);
    currentPlacementData.placementPositionText = placementText;
    $('.placementPositionText').text(currentPlacementData.placementPositionText);
}
function clearInputAndLabel(mode) {
    $(`.${mode}__sponsor-input`).val('');
    $(`.${mode}__sponsor-input`).removeClass('is--active');
    $(`.${mode}__sponsor-input-label`).removeClass('is--active');
    $(`.clear-text-btn`).each(function () {
        $(this).hide();
    });
}

function hideErrorMessage(mode = 'placement') {
    const errorSpan = $(`.${mode}__no_results`);
    $(`.${mode}__sponsor-input-label`).removeClass('is--active');
    errorSpan.hide();
}

function hideResults(mode = 'placement') {
    const resultList = $(`.${mode}__results-list`);
    resultList.empty();
}

function displayCurrentPlacementDataOnCard() {
    $('.enrollSponsorNameText').text(
        getSponsorDisplay(
            currentPlacementData.enrollingSponsorId,
            currentPlacementData.enrollingSponsorName,
            true
        )
    );
    $('.placementSponsorNameText').text(
        getSponsorDisplay(
            currentPlacementData.placementSponsorId,
            currentPlacementData.placementSponsorName,
            true
        )
    );
    $('.placementPositionText').text(currentPlacementData.placementPositionText);

    if(
        currentPlacementData.hasDelegate &&
    currentPlacementData.enrollingSponsorId.toString() !== currentMemberId
    ) {
        $('.placementPositionText').closest('div').hide(); // hide placement position section (on page)

        $('.placementSponsorNameText').hide();
        $('.placement-sponsor').hide(); // hide placement name
        $('.assisted-enrollment__placement-card-delegate').show();
        $('.placement-tooltip-btn').hide();
    } else {
        $('.placementPositionText').closest('div').show();
        // squeeze the placement name section
        $('.placementSponsorNameText').show();

        $('.assisted-enrollment__placement-card-delegate').hide();
        $('.placement-tooltip-btn').show();
    }
}

function displayCurrentPlacementData() {
    // modal enrolling sponsor
    let enrollingSponsorDisplay = getSponsorDisplay(
        currentPlacementData.enrollingSponsorId,
        currentPlacementData.enrollingSponsorName
    );
    $('.enroll-sponsor').text(enrollingSponsorDisplay);

    // modal placement sponsor
    $('.placement-sponsor').text(
        getSponsorDisplay(
            currentPlacementData.placementSponsorId,
            currentPlacementData.placementSponsorName
        )
    );
    $('.assisted-enrollment__select').val(currentPlacementData.placementPosition);

    // if authenticated member Is Not enrollment sponsor AND selected enrollment sponsor has a placement delegate
    if(
        currentPlacementData.hasDelegate &&
    currentPlacementData.enrollingSponsorId.toString() !== currentMemberId
    ) {
        $('.editPlacementButton').hide();
        $('.sponsorHasDelegate').text(enrollingSponsorDisplay);
        $('.assisted-enrollment__placement-delegate').show();
        $('.assisted-enrollment__placement-delegate').css('display', 'inline');
        $('.placement-dropdown, .placement-input-section').hide(); // hide placement location dropdown
        $('.placement-sponsor').hide();
    } else {
        $('.editPlacementButton').show();
        $('.assisted-enrollment__placement-delegate').hide();
        $('.placement-dropdown, .placement-input-section').show();
        $('.placement-sponsor').show();
    }
}

function getSponsorDisplay(sponsorId, sponsorName, isNameOnly) {
    if(sponsorId === currentMemberId || sponsorId === Number(currentMemberId)) {
        return youLabel;
    }

    return isNameOnly ? sponsorName : `${sponsorName} (#${sponsorId})`;
}

function clearEnrollingSearchInputAndResults() {
    let HTMLmarkup = sponsorItemTmpl([]);
    $('.enroll__results-list').html(HTMLmarkup);
    $('.enroll__no_results').hide();
    $('.enroll__sponsor-input').val('');
    $('.enroll__sponsor-input-label').hide();
}

function clearPlacementSearchInputAndResults() {
    let HTMLmarkup = placementSponsorItemTmpl([]);
    $('.placement__results-list').html(HTMLmarkup);
    $('.placement__no_results').hide();
    $('.placement__sponsor-input').val('');
    $('.placement__sponsor-input-label').hide();
}

function setAssignedPlacementSponsor() {
    let $this = $(this);
    let placementSponsorId = $this.data('memberid');
    let placement = placementDataResult.find(
        (i) => i.placementSponsorId === placementSponsorId
    );
    if(!placement) {
        console.error(
            `cannot find placement data for ${placementSponsorId}`,
            placementDataResult
        );
        return;
    }

    setCurrentPlacement(placement);
    displayCurrentPlacementData();
    if(!allFlowEnabled) closeEditPlacementModal();
    hideResults('placement');
}

function closeEditPlacementModalAndClearInputs(closeModal = true) {
    if(closeModal) {
        $('#editPlacementModal').modal('hide');
    }
    hideErrorMessage('placement');
    hideResults('placement');
    clearInputAndLabel('placement');
    hideErrorMessage('enroll');
    hideResults('enroll');
    clearInputAndLabel('enroll');
}

async function saveAssistedEnrollment(e) {
    e.preventDefault();

    // if the current data does not have enrollingSponsorId set then return error
    if(!currentPlacementData.enrollingSponsorId) {
        console.error('placement data missing', currentPlacementData);
        return;
    }

    try {
        loadSpinner();
        setCurrentPlacementPosition(
            $('.assisted-enrollment__select').val(),
            $('.assisted-enrollment__select option:selected').text()
        );
        let result = await aeService.saveSponsor(currentPlacementData);
        if(result) {
            displayCurrentPlacementData();
            displayCurrentPlacementDataOnCard();
            allFlowEnabled ? closeEditPlacementModalAndClearInputs() : closeModal();
        }
        stopSpinner();
    } catch (e) {
        console.log(e);
    }
}

function closeModal() {
    $('.placement').hide();
    $('.enroll').hide();
    $('.main').show();
    $('#assistedEnrollment').modal('hide');
}

function showOrHideLabelForEnrollInput() {
    let $this = $(this);
    const $sponserInputLabel = $('.enroll__sponsor-input-label');
    const closeBtn = $this.siblings('.clear-text-btn');
    if($this.val() === '') {
        if(allFlowEnabled) {
            closeBtn.hide();
            $sponserInputLabel.removeClass('is--active');
        } else $sponserInputLabel.hide().removeClass('is--active');
    } else {
        $('.enroll__sponsor-input-label').show().addClass('is--active');
        closeBtn.show();
    }

    $('.placement-label').show();
}

function showOrHideLabelForPlacementInput() {
    let $this = $(this);
    const $placementInputLabel = $('.placement__sponsor-input-label');
    const closeBtn = $this.siblings('.clear-text-btn');
    if($this.val() === '') {
        if(allFlowEnabled) {
            closeBtn.hide();
            $placementInputLabel.removeClass('is--active');
        } else $placementInputLabel.hide().removeClass('is--active');
    } else {
        $placementInputLabel.show().addClass('is--active');
        closeBtn.show();
    }
}

function openModal() {
    $('#assistedEnrollment').modal('show');
}

async function resetPlacementSettings(e) {
    if(e) {
        e.preventDefault();
    }
    let resetSetting = '';
    try {
        loadSpinner();
        resetSetting = await aeService.resetMemberPlacement({
            memberId: $('#currentMemberId').val()
        });
        currentMemberId = $('#currentMemberId').val();
        currentPlacementData.enrollingSponsorId = resetSetting.enrollingMemberId;
        currentPlacementData.placementSponsorId = resetSetting.placementMemberId;
        currentPlacementData.placementSponsorName =
      resetSetting.placementMemberName;
        currentPlacementData.enrollingSponsorName =
      resetSetting.enrollingMemberName;
        currentPlacementData.placementPosition = resetSetting.placementLocation;
        currentPlacementData.hasDelegate = resetSetting.hasDelegate;
        currentPlacementData.IsPlacementConfirmed = false;
        displayCurrentPlacementData();
        stopSpinner();
        closeEditPlacementModalAndClearInputs(false);
    } catch (e) {
        console.log(e);
    }
}

function initEventHandlers() {
    allFlowEnabled = !!$('#checkout-parent-container').hasClass(
        'all-flow-checkout'
    );
    console.log(allFlowEnabled);
    $('.close').on('click', allFlowEnabled ? closeEditPlacementModalAndClearInputs() : closeModal());
    $('.editEnrollButton').on('click', openEditEnrollModal);
    $('.editPlacementButton').on('click', openEditPlacementModal);
    $('.cancelEnrollButton').on('click', closeEditEnrollModal);
    $('.cancelPlacementButton').on('click', closeEditPlacementModal);
    $('.enroll__search_button').on('click', searchEnrollInput);
    $('.enroll__sponsor-input').on('keypress', function (e) {
    // if not enter key, exit
        if(e.which !== 13) return;
        e.preventDefault();
        searchEnrollInput();
    });

    $('.placement__search_button').on('click', searchPlacementInput);
    $('.placement__sponsor-input').on('keypress', function (e) {
    // if not enter key, exit
        if(e.which !== 13) return;
        e.preventDefault();
        searchPlacementInput();
    });
    $('.placement__results-list').on(
        'click',
        `${
            allFlowEnabled
                ? '.placement__results-list-item .update-btn'
                : '.placement__results-list-item'
        }`,
        setAssignedPlacementSponsor
    );
    $('.enroll__results-list').on(
        'click',
        `${
            allFlowEnabled
                ? '.enroll__results-list-item .update-btn'
                : '.enroll__results-list-item'
        }`,
        setAssignedEnrollSponsor
    );
    $('.enroll__sponsor-input').on('input', showOrHideLabelForEnrollInput);
    $('.placement__sponsor-input').on('input', showOrHideLabelForPlacementInput);
    $('.assisted-enrollment__save').on('click', saveAssistedEnrollment);
    $('.enrollment-btn').on('click', openModal);
    $('.placement-selection-btn').on('click', openModal);
    $('.assisted-enrollment__reset-message-link').on(
        'click',
        resetPlacementSettings
    );
    $('.cancel-edit').on('click', () => {
        setTimeout(() => {
            closeEditPlacementModalAndClearInputs();
        }, 200);
    });
}

function clearTextFromField(e) {
    e.preventDefault();
    const $this = $(this);
    const label = $this.siblings('label');
    const input = $this.siblings('input');
    input.val('');
    input.removeClass('is--active');
    label.removeClass('is--active');
    $this.hide();
}

function focusInputContainer() {
    const $this = $(this);
    const input = $this.siblings('input');
    input.focus();
}

function initPlacementVariables() {
    currentMemberId = $('#currentMemberId').val();
    currentPlacementData.enrollingSponsorId = $('#enrollingSponsorId').val();
    currentPlacementData.enrollingSponsorName = $('#enrollingSponsorName').val();
    currentPlacementData.placementSponsorId = $('#placementSponsorId').val();
    currentPlacementData.placementSponsorName = $('#placementSponsorName').val();
    currentPlacementData.placementPosition = $('#placementPosition').val();
    currentPlacementData.placementPositionText = $(
        '#placementPositionText'
    ).val();
    currentPlacementData.hasDelegate =
    $('#placementHasDelegate').val() === 'true';
    currentPlacementData.IsPlacementConfirmed =
    $('#isPlacementConfirmed').val() === 'true';
    let youText = $('#labelYouText').val();
    if(youText) {
        youLabel = youText;
    }
    $('.clear-text-btn').on('click', clearTextFromField);
    $('.enroll__sponsor-input-label, .placement__sponsor-input-label').on(
        'click',
        focusInputContainer
    );
    // $('.enroll__sponsor-input-label, .placement__sponsor-input-label').hover(function () {
    //     $(this).siblings('input').css('border-color', '#54585A');
    // }, function () { $(this).siblings('input').css('border-color', '#EDEEEE'); });
}

$(function () {
    initEventHandlers();
    initPlacementVariables();
    displayCurrentPlacementData();
    displayCurrentPlacementDataOnCard();
});
